import { render, staticRenderFns } from "./IndexUserRegAnalyze.vue?vue&type=template&id=2c0d8d02&scoped=true&"
import script from "./IndexUserRegAnalyze.vue?vue&type=script&lang=js&"
export * from "./IndexUserRegAnalyze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d8d02",
  null
  
)

export default component.exports